import React from "react";
import { GridItem } from "../common/GridItem";
import { Field, Input, makeStyles, tokens } from "@fluentui/react-components";
import { Controller, UseFormReturn } from "react-hook-form";
import { ISignForm } from "../../interfaces/ISignForm";
import { Grid } from "../common/Grid";
import { useTranslation } from "react-i18next";
type ContactInformationFormProps = {
  signForm: UseFormReturn<ISignForm, any, ISignForm>;
};
const useStyles = makeStyles({
  label: {
    fontWeight: tokens.fontWeightBold,
    fontSize: tokens.fontSizeBase500,
  },
  inputHeight: {
    height: tokens.spacingVerticalXXXL,
  },
});
export const ContactInformationForm = ({
  signForm,
}: ContactInformationFormProps) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const { control } = signForm;
  return (
    <>
      <GridItem size="8/12">
        <Controller
          name={`customer.companyName`}
          control={control}
          rules={{ required: true }}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Field
              label={t("field.companyName")}
              className={styles.label}
              required
              validationState={error ? "error" : undefined}
              validationMessage={
                error ? t("validation.companyName") : undefined
              }
              size="medium"
            >
              <Input
                type="text"
                value={value ?? ""}
                onChange={onChange}
                className={styles.inputHeight}
                max={100}
              />
            </Field>
          )}
        />
      </GridItem>
      <GridItem size="8/12">
        <Controller
          name={`customer.name`}
          control={control}
          rules={{ required: true }}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <Field
              label={t("field.name")}
              className={styles.label}
              required
              validationState={error ? "error" : undefined}
              validationMessage={error ? t("validation.name") : undefined}
              size="medium"
            >
              <Input
                type="text"
                value={value ?? ""}
                onChange={onChange}
                className={styles.inputHeight}
                max={100}
              />
            </Field>
          )}
        />
      </GridItem>

      <GridItem size="8/12">
        <Grid>
          <GridItem size="6/12">
            <Controller
              name={`customer.email`}
              control={control}
              rules={{
                required: true,
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: t("validation.emailFormat"),
                },
              }}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <Field
                  label={t("field.email")}
                  className={styles.label}
                  required
                  validationState={error ? "error" : undefined}
                  validationMessage={error?.message}
                  size="medium"
                >
                  <Input
                    type="email"
                    value={value ?? ""}
                    onChange={onChange}
                    className={styles.inputHeight}
                    max={100}
                  />
                </Field>
              )}
            />
          </GridItem>
          <GridItem size="6/12">
            <Controller
              name={`customer.phone`}
              control={control}
              rules={{
                required: true,
                pattern: {
                  value: /^[0-9\s+()-]*$/,
                  message: t("validation.phoneFormat"),
                },
              }}
              render={({
                field: { value, onChange },
                fieldState: { error },
              }) => (
                <Field
                  label={t("field.phone")}
                  className={styles.label}
                  required
                  validationState={error ? "error" : undefined}
                  validationMessage={error?.message}
                  size="medium"
                >
                  <Input
                    type="text"
                    value={value ?? ""}
                    onChange={onChange}
                    className={styles.inputHeight}
                    max={30}
                  />
                </Field>
              )}
            />
          </GridItem>
        </Grid>
      </GridItem>
    </>
  );
};
